import * as tslib_1 from "tslib";
import clearNewCategoryState from '../actions/clearNewCategoryState';
import setCategoryNameOnNewCategory from '../actions/setCategoryNameOnNewCategory';
import store from '../store/store';
import { observer } from 'mobx-react';
import { TextField } from 'office-ui-fabric-react/lib/components/TextField';
import { isCategoryNameDuplicate, isCategoryNameEmptyOrWhitespace } from 'owa-categories';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var CategoryTextField = /** @class */ (function (_super) {
    tslib_1.__extends(CategoryTextField, _super);
    function CategoryTextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onTextFieldKeyDown = function (evt) {
            // Need stop propagation to prevent discard the whole category settings
            evt.stopPropagation();
            switch (evt.which) {
                case 13 /* enter */:
                    _this.props.trySaveNewCategory(0 /* OnEnterOnTextField */);
                    break;
                case 27 /* escape */:
                    clearNewCategoryState();
                    break;
            }
        };
        _this.onGetErrorMessage = function (value) {
            // Do not show any error message if user hasn't started typing
            if (!_this.textField || _this.textField.value === '') {
                return undefined;
            }
            if (isCategoryNameEmptyOrWhitespace(_this.textField.value)) {
                return strings.options_empty_category_error;
            }
            if (isCategoryNameDuplicate(_this.textField.value)) {
                return strings.options_duplicate_category_error;
            }
            // Do not show any error message
            return undefined;
        };
        return _this;
    }
    CategoryTextField.prototype.focus = function () {
        this.textField.focus();
    };
    CategoryTextField.prototype.render = function () {
        var _this = this;
        return (React.createElement(TextField, { autoFocus: true, componentRef: function (ref) {
                _this.textField = ref;
            }, onBlur: this.props.onBlurOnTextField, onChanged: setCategoryNameOnNewCategory, onGetErrorMessage: this.onGetErrorMessage, onKeyDown: this.onTextFieldKeyDown, placeholder: strings.options_category_textfield_placeholder, value: store.newCategory.Name }));
    };
    CategoryTextField = tslib_1.__decorate([
        observer
    ], CategoryTextField);
    return CategoryTextField;
}(React.Component));
export default CategoryTextField;
//# sourceMappingURL=CategoryTextField.js.map